import { render, staticRenderFns } from "./input-mask.component.vue?vue&type=template&id=12be94d9&"
import script from "./input-mask.component.vue?vue&type=script&lang=js&"
export * from "./input-mask.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports